import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import { LocalizeProvider } from 'react-localize-redux';
import Review from './containers/Review';
import Page404 from './pages/Page404';
import Page500 from './pages/Page500';


function App() {
  return (
    <LocalizeProvider>
      <Router basename={'/review'}>
        <Route path="/site/:id" component={Review} />
        <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
        <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
      </Router>
    </LocalizeProvider>

  );
}

export default App;
